import * as actions from '../../Action/Tenant/TenantCreateUserForm'

export const initialState = {
    name:"",
    role:"",
    jobTitle:"",
    email:"",
    phone:"",
    password:"",
    isTenantAdmin:"",
    loaderStatus:false,
    userCreationFailure: null,
    workstreamData: [],
    workStreamIds:[],
    userLimits:0
}

export default function reducer(state = initialState, action){
    
    switch(action.type){
        case actions.TENANATNAME : return tenantName(state,action);
        case actions.TENANTROLE : return tenantRole(state,action);
        case actions.TENANTJOBTITLE: return tenantJobTitle(state,action)
        case actions.TENANTEMAIL: return tenantMail(state,action)
        case actions.TENANTPHONE: return tenantPhone(state,action)
        case actions.TENANTPASSWORD: return tenantPassword(state,action)
        case actions.ISTENANTADMIN: return isTenantAdmin(state,action)
        case actions.RESETDATA:  return resetData(state,action)
        case actions.LOGGEDINLOADER: return loggedInLoader(state,action)
        case actions.USERCREATIONFAILURE: return userCreationFailure(state, action)
        case actions.WORKSTREAMDATA: return workstreamData(state, action)
        case actions.WORKSTREAMIDS: return workStream(state, action)
    default: return state
    }
}

const tenantName = (state,action) => {
    return {
        ...state,
        name: action.payload
    }
}

const tenantRole = (state,action) => {
    return {
        ...state,
        role: action.payload
    }
}

const tenantJobTitle = (state,action) => {
    return {
        ...state,
        jobTitle: action.payload
    }
}

const tenantMail = (state,action) => {
    return {
        ...state,
        email: action.payload
    }
}


const tenantPhone = (state,action) => {
    return {
        ...state,
        phone: action.payload
    }
}

const tenantPassword = (state,action) => {
    return {
        ...state,
        password : action.payload
    }
}

const isTenantAdmin = (state,action) => {
    return {
        ...state,
        isTenantAdmin : action.payload
    }
}

const workStream = (state, action) => {
    return {
        ...state,
        workStreamIds : action.payload
    }
}

const resetData = (state,action) => {
    return {
        ...state,
        name:"",
        role:"",
        jobTitle:"",
        email:"",
        phone:"",
        password: "",
        isTenantAdmin:"",
        workstreamData: [],
        workStreamIds:[],
        userLimits:0
    }
}

const loggedInLoader =(state,action) => {
    return{
        ...state,
        loaderStatus: action.payload
    }
}

const userCreationFailure = (state,action) => {
    return {
        ...state,
        userCreationFailure: action.payload
    }
}

const workstreamData = (state,action) => {
    return {
        ...state,
        workstreamData: action.payload
    }
}